class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.updateFreeShippingProgress();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  async updateFreeShippingProgress() {
    const container = this.querySelector('#cart-notification-free-shipping');
    if (!container) return;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const cart = await response.json();
      const threshold = Number(container.dataset.threshold) || 9900;
      const remaining = Math.max(threshold - cart.total_price, 0);
      const progress = Math.min(Math.round((cart.total_price / threshold) * 100), 100);
      const currency = container.dataset.currency || cart.currency || 'CAD';
      const locale = document.documentElement.lang || 'fr-CA';
      const money = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(remaining / 100);
      const message = container.querySelector('[data-free-shipping-message]');
      const bar = container.querySelector('[data-free-shipping-bar]');
      const track = container.querySelector('[role="progressbar"]');

      if (message) {
        message.innerHTML =
          remaining > 0
            ? `Plus que <strong>${money}</strong> pour la livraison gratuite au Canada / <strong>${money}</strong> away from free shipping in Canada.`
            : '<strong>Livraison gratuite débloquée au Canada! / Free shipping unlocked in Canada!</strong>';
      }
      if (bar) bar.style.width = `${progress}%`;
      if (track) track.setAttribute('aria-valuenow', String(progress));
    } catch (error) {
      // The standard cart notification remains fully usable if the progress request fails.
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
